import { IApiResponse, IClaimNote } from '@/types';
import { AsyncRefWrapper } from '@/classes/asyncRefWrapper';
import { NoteControllerApi } from '@/hooks/api/noteControllerApi';

export class NoteAdd extends AsyncRefWrapper<IClaimNote | undefined> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private _getNoteIdFromResponseHeaders(headers: any): number {
    const locationArr = headers.location.split('/'); // location example: http://localhost:8888/note/821, http://localhost:8888/reply/821
    return Number(locationArr[locationArr.length - 1]);
  }

  public constructor() {
    super(undefined);
  }

  public addNote(value: IClaimNote): Promise<void> {
    return this.loadFrom(
      NoteControllerApi.addNote(value).then(
        (response: IApiResponse<void>): IApiResponse<IClaimNote> => {
          return {
            ...response,
            data: {
              ...value,
              id: this._getNoteIdFromResponseHeaders(response.headers),
            },
          };
        }
      )
    );
  }
}
